import React from "react";
import { useSelector } from "react-redux";
import {
  Typography,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  CircularProgress,
  Box,
} from "@mui/material";
import { format } from "date-fns";
import * as selectors from "selectors";
import { Email } from "./interface";

export const EmailLogOnlyPage: React.FC = () => {
  const sentEmailList = useSelector(selectors.getSentEmails);
  const sentEmailsLoading = useSelector(selectors.getSentEmailsLoading);

  if (sentEmailsLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", padding: "48px" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (sentEmailList.length === 0) {
    return (
      <Typography variant="body1" sx={{ padding: "24px" }}>
        No emails found for this client
      </Typography>
    );
  }

  return (
    <Stack sx={{ padding: "24px" }}>
      <Typography variant="h3" sx={{ mb: 7 }}>Email Log</Typography>
      <TableContainer>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            <TableCell width="30%">Email Address &amp; Subject Line</TableCell>
            <TableCell width="15%">Status</TableCell>
            <TableCell width="15%">Times Email was Opened</TableCell>
            <TableCell width="15%">Number links clicked</TableCell>
            <TableCell width="25%">Last Activity</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sentEmailList.map((email: Email, index: number) => (
            <TableRow
              key={email.msg_id}
              sx={{
                backgroundColor: index % 2 === 0 ? "#ECFAFA" : "transparent",
              }}
            >
              <TableCell>
                <Typography variant="body2">{email.from_email}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {email.subject}
                </Typography>
              </TableCell>
              <TableCell sx={{ textTransform: "capitalize" }}>
                {email.status}
              </TableCell>
              <TableCell>{email.opens_count}</TableCell>
              <TableCell>{email.clicks_count}</TableCell>
              <TableCell>
                {email.last_event_time
                  ? format(new Date(email.last_event_time), "MMM d, yyyy h:mm a")
                  : ""}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      </TableContainer>
    </Stack>
  );
};

export default EmailLogOnlyPage;
